import { useSendbirdStateContext } from "@sendbird/uikit-react";
import ConnectionHandler from "@sendbird/uikit-react/handlers/ConnectionHandler";
import { useEffect, useRef } from "react";
import { uuidv4 } from "../../../../utils/uuid/uuidv4";

const useReconnectionHandler = ({ channelUrl }) => {
  const channelUrlRef = useRef(channelUrl);

  useEffect(() => {
    channelUrlRef.current = channelUrl;
  }, [channelUrl]);

  const { stores } = useSendbirdStateContext();
  const sdk = stores?.sdkStore?.sdk;

  useEffect(() => {
    const uniqueHandlerId = uuidv4();

    try {
      const handler = new ConnectionHandler({
        onDisconnected() {
          console.log("onDisconnected");
        },
        onReconnectStarted() {
          console.log("onReconnectStarted");
        },
        onReconnectSucceeded: async () => {
          console.log("onReconnected");
          if (channelUrlRef.current) {
            const channel = await sdk.groupChannel.getChannel(
              channelUrlRef.current
            );
            await channel.refresh();
          }
        },
        onReconnectFailed() {
          // Optionally, update UI to inform the user
        },
      });

      if (typeof sdk?.addConnectionHandler === "function") {
        sdk.addConnectionHandler(uniqueHandlerId, handler);
        console.log("Added ConnectionHandler", uniqueHandlerId);
      }
      return () => {
        try {
          sdk.removeConnectionHandler(uniqueHandlerId);
          console.log("Removed ConnectionHandler", uniqueHandlerId);
        } catch {
          //
        }
      };
    } catch {
      console.error(
        "Something went wrong with the connectionHandler registration"
      );
    }
  }, [sdk]);
};

export default useReconnectionHandler;
